<script setup>
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import DashboardAppFrame from 'dashboard/components/widgets/DashboardApp/Frame.vue';
import LoadingState from 'dashboard/components/widgets/LoadingState.vue';

const route = useRoute();
const store = useStore();
const { t } = useI18n();

const dashboardApps = useMapGetter('dashboardApps/getRecords');
const uiFlags = useMapGetter('dashboardApps/getUIFlags');

const dashboardAppId = computed(() => Number(route.params.dashboardAppId));
const activeDashboardApp = computed(() =>
  dashboardApps.value.find(app => app.id === dashboardAppId.value)
);

onMounted(() => {
  store.dispatch('dashboardApps/get');
});
</script>

<template>
  <div class="flex flex-col w-full h-full overflow-hidden">
    <LoadingState
      v-if="uiFlags.isFetching && !activeDashboardApp"
      :message="t('DASHBOARD_APPS.LOADING_MESSAGE')"
    />
    <DashboardAppFrame
      v-else-if="activeDashboardApp"
      :config="activeDashboardApp.content"
      is-visible
      :position="dashboardAppId"
    />
  </div>
</template>
